import { useState, useEffect, React } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { useLocation } from 'react-router-dom'
import registro from '../../asses/img/logoRegistro.png';
import FooterBeparking from '../../components/footer/beparking';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useForm, Controller } from 'react-hook-form';
import { URL_AWS } from '../../constans/servidor';

export default function ResetPassword() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get('token');

  const [imagen, setImagen] = useState(registro);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showLoading, setShowLoading] = useState(false);
  const [touched, setTouched] = useState({
    new: false,
    confirm: false
  });

  const {
    control,
    watch,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();


  const onSubmit = async () => {
    setShowLoading(true);
    try {
      if (!token) {
        setShowLoading(false);
        return toast.error('Token inválido');
      }
      if (!newPassword || !confirmPassword) {
        setShowLoading(false);
        return toast.error('Todos los campos son obligatorios');
      }

      if(newPassword !== confirmPassword){
        setShowLoading(false);
        return toast.error('Las contraseñas no coinciden');
      }

      if(newPassword.length < 6){
        setShowLoading(false);
        return toast.error('La contraseña debe tener al menos 6 caracteres');
      }

      const response = await axios.post(`${URL_AWS}/Suppliers/resetPasswordSupplier`, { assignedToken: token, newPassword, confirmPassword });
      console.log(response.data);
      if (response.data.status === true) {
        toast.success('Contraseña reseteada correctamente');
        window.location.href = '#/retentionCertificates/createUser?login=open';
        setShowLoading(false);
        return;
      } else {
        toast.error(response.data.message || 'Error al resetear la contraseña');
        setShowLoading(false);
        return;
      }
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message || 'Error al resetear la contraseña');
      setShowLoading(false);
    }
  }

  return (
    <>
      <Container>
        <Row className="pbottom-40">
          <Col xs={12} sm={12} md={6} lg={6} xl={6} className="text-center ">
            <img
              src={imagen}
              className="img-fluid mtop-30"
              alt="Reset Password"
            />
          </Col>
          <Col xs={12} sm={12} md={6} lg={6} xl={6} className="be-registro">
            <h3 className='mb-5'>crear una nueva contraseña.</h3>
            <Form onSubmit={(e) => { e.preventDefault(); onSubmit() }}>
              <Form.Group controlId="formBasicEmail">
                <Form.Label>Nueva contraseña</Form.Label>
                <Controller
                  name="password"
                  control={control}
                  rules={{ required: true }}
                  defaultValue={newPassword}
                  render={({ field: { onChange, onBlur, value } }) => (
                    <div style={{ position: 'relative' }}>
                      <Form.Control
                        type={showPassword ? 'text' : 'password'}
                        onBlur={onBlur}
                        onChange={(e) =>
                          onChange(e.target.value) &&
                          setNewPassword(e.target.value)
                        }
                        value={value}
                        placeholder="Ingresa tu contraseña"
                      />
                      <div
                        style={{
                          position: 'absolute',
                          top: '50%',
                          right: '10px',
                          transform: 'translateY(-50%)',
                          cursor: 'pointer',
                        }}
                        onClick={() =>
                          setShowPassword(
                            (prevShowPassword) => !prevShowPassword
                          )
                        }
                      >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                      </div>
                    </div>
                  )}
                />
                {touched.new && newPassword.length > 0 && newPassword.length < 6 && (
                  <Form.Text id="passwordHelpBlock" className="error">
                    La contraseña debe tener al menos 6 caracteres
                  </Form.Text>
                )}
                {touched.new && newPassword.length > 0 && newPassword.length > 0 && newPassword !== confirmPassword && (
                  <Form.Text id="passwordHelpBlock" className="error">
                    La contraseña deben coincidir
                  </Form.Text>
                )}
              </Form.Group>
              <Form.Group controlId="formBasicEmail">
                <Form.Label>Confirmar contraseña</Form.Label>
                <Controller
                  name="cpassword"
                  control={control}
                  rules={{
                    required: true,
                  }}
                  defaultValue={confirmPassword}
                  render={({ field: { onChange, onBlur, value } }) => (
                    <div style={{ position: 'relative' }}>
                      <Form.Control
                        type={showConfirmPassword ? 'text' : 'password'}
                        onBlur={onBlur}
                        onChange={(e) => {
                          onChange(e.target.value) &&
                            setConfirmPassword(e.target.value)
                        }}
                        value={value}
                        placeholder="Confirma tu contraseña"
                      />
                      <div
                        style={{
                          position: 'absolute',
                          top: '50%',
                          right: '10px',
                          transform: 'translateY(-50%)',
                          cursor: 'pointer',
                        }}
                        onClick={() =>
                          setShowConfirmPassword(
                            (prevShowConfirmPassword) =>
                              !prevShowConfirmPassword
                          )
                        }
                      >
                        {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                      </div>
                    </div>
                  )}
                />
                {touched.confirm && confirmPassword.length > 0 && newPassword !== confirmPassword && (
                  <Form.Text id="passwordHelpBlock" className="error">
                    La contraseña deben coincidir
                  </Form.Text>
                )}
                {touched.confirm && confirmPassword.length > 0 && confirmPassword.length < 6 && (
                  <Form.Text id="passwordHelpBlock" className="error">
                    La contraseña debe tener al menos 6 caracteres
                  </Form.Text>
                )}
              </Form.Group>
              <div className="text-center">
                {showLoading ? <div className="container-sniper text-center"></div> : (
                  <Button variant="primary" size="sm" type="submit" className='mt-3 btn-borde-verde'>Resetear contraseña</Button>
                )}
              </div>
            </Form>
          </Col>
        </Row>
      </Container>
      <FooterBeparking />
    </>

  )
}